const AUTH_TOKEN_KEY = "__ct";

class Auth {
  constructor() {
    this._observers = [];

    this._notify = this._notify.bind(this);
    this.clearToken = this.clearToken.bind(this);
    this.setToken = this.setToken.bind(this);
    this.subscribe = this.subscribe.bind(this);
    this.unsubscribe = this.unsubscribe.bind(this);
  }

  _notify() {
    const token = this.getToken();

    this._observers.forEach((cb) => cb(token));
  }

  clearToken() {
    this.setToken("");
  }

  setToken(token) {
    if (window && window.localStorage) {
      window.localStorage.setItem(AUTH_TOKEN_KEY, token);

      this._notify();
    }
  }

  getToken() {
    if (window && window.localStorage) {
      return window.localStorage.getItem(AUTH_TOKEN_KEY);
    }
  }

  subscribe(cb) {
    this._observers.push(cb);

    return () => {
      this.unsubscribe(cb);
    };
  }

  unsubscribe(cb) {
    this._observers = this._observers.filter((fn) => fn !== cb);
  }
}

const auth = new Auth();

export { Auth, auth, AUTH_TOKEN_KEY };
